export default __webpack_public_path__ + "static/media/Appointment.318d78a4.svg";